<template>
    <div class="h-[200px] w-full border-t border-green-500 bg-green-300 px-6 pt-[25px] pb-[25px]">
        <div class="mb-4">
            <div class="mb-4 flex justify-between">
                <p class="text-xsm leading-none lg:text-sm">
                    {{ $snippets['headless.cart.totalProducts'] }}
                </p>
                <p class="text-xsm leading-none font-bold lg:text-sm"><Price :price="subtotal" /></p>
            </div>
            <div class="flex justify-between">
                <p class="text-xsm leading-none lg:text-sm">
                    {{ $snippets['headless.cart.shipping'] }}
                </p>
                <p class="text-xsm leading-none lg:text-sm" v-if="shippingTotal > 0">
                    <Price :price="shippingTotal" />
                </p>
                <p class="text-xsm leading-none lg:text-sm" v-else>
                    {{ $snippets['headless.cart.free'] }}
                </p>
            </div>
        </div>
        <NuxtLink
            class="btn btn-yellow mb-2 flex! w-full! items-center justify-center leading-none"
            to="/checkout?step=1"
            @click="invokeCartSidebar()">
            <IconShoppingBag class="mr-3 size-4" />
            {{ $snippets['headless.cart.order'] }}
        </NuxtLink>
        <div class="flex justify-center">
            <p class="flex items-center justify-center leading-none text-green-700">
                <TruckIcon class="mr-1 size-5" />
                <span class="mt-0.5 text-xs">{{ $snippets['headless.cart.shippingTime'] }}</span>
            </p>
        </div>
    </div>
</template>
<script setup lang="ts">
    import { TruckIcon } from '@heroicons/vue/24/outline';

    defineProps<{
        total: number | string;
        shippingTotal: number | string;
        subtotal: number | string;
    }>();

    const cartSidebarStore = useCartSidebarStore();
    const { invokeCartSidebar } = cartSidebarStore;
</script>
